import React, { PropTypes, Component } from 'react';

import {
  NitroLinks,
  NitroHeading,
  NitroDivider,
  NitroBadge,
  NitroTabs,
  NitroButton,
  NitroButtonGroup,
  NitroText
} from 'nitro-components';

import formCheckEmail from '../../../../utils/forms/form-email-check';

import styled from 'styled-components';

const RecipientsContainer = styled.section`
  margin-top: 20px;
`;

const RecipientListHeading = styled.div`
  padding: 12px 16px;
  background: ${props => props.theme.color.border};
  color: ${props => props.theme.color.base1};
  font-family: ${props => props.theme.font.bold};
  font-size: ${props => props.theme.size['3']}px;
`;

const AddReceipients = styled.div`
  text-align: center;
  margin-top: 10px;
`;
const RecipientList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;
const RecipientListItem = styled.li`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px;
  border-bottom: 1px solid ${props => props.theme.color.base3};
  font-size: 14px;
  &:nth-child(even) {
    background: ${props => props.theme.color.white};
  }
`;
const RecipientListEmail = styled.div`
  max-width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 8px 0;
`;

const RecipientInput = styled.input`
  width: 250px;
  padding: 8px 0;
  background: none;
  border: none;
  outline: none;
`;

class Recipients extends Component {
  constructor(props) {
    super(props);
    let recipients = { ...props.recipients };
    //
    if (recipients.to.length === 0) {
      recipients = { ...recipients, to: [props.username] };
    }
    this.state = {
      activeTab: 'to',
      recipients,
      action: '',
      actionIndex: -1,
      inputValue: ''
    };
  }

  // Background click close dropdown list
  // Ref: https://discuss.reactjs.org/t/how-to-calculate-jqyery-closest-in-react/1988

  // Does not really need below logic as once initalise local state from props
  // local state will be self managed and no longer updated by passed in props
  componentWillReceiveProps(nextProps) {
    // let recipients = { ...nextProps.recipients };
    // //
    // if (recipients.to.length === 0) {
    //   recipients = { ...recipients, to: [this.props.username] };
    // }
    //
    // this.setState({
    //   recipients: recipients
    // });
  }

  get data() {
    return this.state.recipients;
  }

  switchTabs = tab => {
    this.setState({
      activeTab: tab.key,
      showAddRecipient: false
    });
    this.cancelAction();
  };

  handleAction = (type, index, address) => {
    this.setState({
      action: type.key,
      actionIndex: index,
      inputValue: address
    });
  };

  handleInputChange = event => {
    const value = event.target.value;
    this.setState({
      inputValue: value
    });
  };

  handleKeyPress = event => {
    if (event.key === 'Enter' && formCheckEmail(this.state.inputValue)) {
      this.confirmAction();
    }
  };

  handleInputBlur = event => {
    if (formCheckEmail(this.state.inputValue)) {
      this.confirmAction();
    } else {
      this.cancelAction();
    }
  };

  confirmAction = () => {
    const {
      activeTab,
      recipients,
      inputValue,
      actionIndex,
      action
    } = this.state;

    let activeList = [...recipients[activeTab]];

    // Add new recipient to the end of array
    if (action === 'add') {
      activeList = [...recipients[activeTab], inputValue];
    }

    // Change value at actionIndex
    if (action === 'edit') {
      activeList[actionIndex] = inputValue;
    }

    // Remove value at actionIndex
    if (action === 'delete') {
      activeList.splice(actionIndex, 1);
    }

    let updatedRecipients = Object.assign({}, recipients);
    updatedRecipients[activeTab] = activeList;

    this.setState({
      recipients: updatedRecipients
    });
    this.cancelAction();
  };

  cancelAction = () => {
    this.setState({
      actionIndex: -1,
      inputValue: '',
      action: ''
    });
  };

  render() {
    const {
      activeTab,
      recipients,
      inputValue,
      actionIndex,
      action
    } = this.state;

    const addressList = recipients[activeTab];

    const editActionGroup = [
      {
        icon: 'edit',
        label: 'edit',
        key: 'edit'
      },
      {
        icon: 'delete',
        label: 'delete',
        key: 'delete'
      }
    ];

    const confirm = {
      icon: 'tick',
      iconVariant: 'theme',
      label: 'confirm',
      action: this.confirmAction
    };

    const cancel = {
      icon: 'close',
      label: 'cancel',
      action: this.cancelAction
    };
    const confirmActionGroup = formCheckEmail(inputValue)
      ? [confirm, cancel]
      : [cancel];

    const input = (
      <RecipientListItem key="input">
        <RecipientInput
          autoFocus
          value={this.state.inputValue}
          onChange={this.handleInputChange}
          onKeyPress={this.handleKeyPress}
        />
        {action === 'add' ? (
          <NitroButton
            disabled={!formCheckEmail(inputValue)}
            size="compact"
            label="Save"
            variant="secondary"
            action={this.confirmAction}
          />
        ) : (
          <NitroLinks
            data={confirmActionGroup}
            noLabel
            gap="16"
            size="4"
            layout="horizontal"
            align="right"
          />
        )}
      </RecipientListItem>
    );

    let addAction = {
      label: '+ Add recipient',
      icon: '',
      key: 'add'
    };
    let variant = 'secondary';

    if (action === 'add') {
      addAction = {
        label: 'Cancel',
        icon: '',
        key: ''
      };
      variant = 'default';
    }

    let addActionGroup = [addAction];

    const recipientsList = (
      <RecipientsContainer>
        <RecipientListHeading>Email Address</RecipientListHeading>

        <RecipientList>
          {addressList.map((address, index) => {
            const isEditing = index === actionIndex && action === 'edit';

            const isDeleting = index === actionIndex && action === 'delete';

            if (isEditing) {
              return input;
            }
            if (isDeleting) {
              return (
                <RecipientListItem key={index}>
                  <NitroText variant="secondary">Remove email?</NitroText>
                  <NitroButtonGroup layout="horizontal">
                    <NitroButton
                      size="compact"
                      label="Confirm"
                      variant="secondary"
                      action={this.confirmAction}
                    />
                    <NitroButton
                      size="compact"
                      label="Cancel"
                      action={this.cancelAction}
                    />
                  </NitroButtonGroup>
                </RecipientListItem>
              );
            }

            return (
              <RecipientListItem key={index}>
                <RecipientListEmail>{address}</RecipientListEmail>
                <NitroLinks
                  layout="horizontal"
                  align="right"
                  data={editActionGroup}
                  noLabel
                  noMargin
                  gap="16"
                  size="4"
                  action={type => this.handleAction(type, index, address)}
                />
              </RecipientListItem>
            );
          })}

          {action === 'add' && input}
        </RecipientList>
      </RecipientsContainer>
    );

    const tabs = [
      {
        label: 'To',
        content: (
          <NitroBadge
            variant="secondary"
            label={recipients.to.length}
            size={10}
          />
        ),
        key: 'to'
      },
      {
        label: 'Cc',
        content: (
          <NitroBadge
            variant="secondary"
            label={recipients.cc.length}
            size={10}
          />
        ),
        key: 'cc'
      },
      {
        label: 'Bcc',
        content: (
          <NitroBadge
            variant="secondary"
            label={recipients.bcc.length}
            size={10}
          />
        ),
        key: 'bcc'
      }
    ];

    return (
      <section>
        <NitroHeading
          size="2"
          variant="secondary"
          label="Recipients"
          align="center"
          noMargin
        />

        <NitroDivider sidePanel variant="base3" />

        <NitroTabs
          data={tabs}
          active={activeTab}
          action={this.switchTabs}
          large
          variant="secondary"
          center
        />

        {recipientsList}

        <AddReceipients>
          <NitroLinks
            variant={variant}
            data={addActionGroup}
            layout="horizontal"
            align="center"
            action={type => this.handleAction(type, -1, '')}
          />
        </AddReceipients>
      </section>
    );
  }
}
Recipients.propTypes = {
  recipients: PropTypes.object,
  username: PropTypes.string
};

export default Recipients;



// WEBPACK FOOTER //
// ./src/features/scheduling-reports/report-edit/components/Recipients.js